// extracted by mini-css-extract-plugin
export var printerCard = "_cn-1";
export var printerCardConfigured = "_cn-2";
export var printerCardError = "_cn-3";
export var printerCardsContainer = "_cn-0";
export var printerIcon = "_cn-8";
export var printerIconConfigured = "_cn-5";
export var printerIconContainer = "_cn-4";
export var printerIconError = "_cn-6";
export var printerIconUnconfigured = "_cn-7";
export var workstationsTableCard = "_cn-9";